<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>
<div>
  <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">
    <div class="card-body padding-all-0px margin-left-0px">
      <div class="modal-body padding-top-0px new-cycle-height2 padding-bottom-0px">
        <div class="row height-100pe">
          <div class="col-md-3 bk-color-light2">
            <div class="row margin-top-10" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
              <div class="col-md-12">
                <div class=" card card-background-transparent card-height">                  
                  <div class="row margin-top-10">
                    <div class="col-md-11 text-align-center padding-left-0px">
                      <img class="img-circle-50 margin-left-10px" [src]="l.PatientImageFile" onError="this.src='dummy.jpg';">                      
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-11 padding-left-0px padding-right-0px text-align-center">
                      <label class="margin-bottom-0px color5 font-weight-bold font-size-19px margin-bottom-0px">{{l.DisplayName}}</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-11 padding-left-0px padding-right-0px text-align-center">
                      <label class="margin-bottom-0px">{{l.FormattedCode}}</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-10 padding-left-0px padding-right-0px text-align-center margin-left-3px">
                      <label class="margin-bottom-0px">                        
                        {{l.Age}},{{l.Gender}}
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-11 padding-left-0px padding-right-0px text-align-center margin-left-3px">
                      <label class="margin-bottom-0px">{{l.Telephone1}}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-9 padding-right-0px">
            <div class="card height-100pe">
            <form class="form " novalidate="" #f="ngForm">
              <div class="card">
                <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
                  <div class="row">
                    <div class="col-md-9 padding-left-0px ">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal margin-right-3px">Egg Donor </label>
                    </div>
                  </div>
                  <div class="row nav-tab-service2">
                    <div class="col-md-12 padding-left-0px">
                      <ul class="nav nav-tabs" id="tabContent">
                        <li class="active margin-right-15px">
                          <a class="nav-itemerp active"
                             href="#NewEpisode"
                             data-toggle="tab">New Episode</a>
                        </li>
                        <li class="margin-right-15px">
                          <a class="nav-itemerp"
                             href="#ConvertCycle"
                             data-toggle="tab">Convert Cycle To Episode</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="tab-content">
                  <div class="tab-pane active" id="NewEpisode">
                    <div class="card-body padding-bottom-0px padding-top-0px margin-left-0px padding-right-0px">
                      <div class="chatsd product-chart-wrapper product-chat-width-new-cycle agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                        <div class="row margin-top-10 ">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row margin-top-5px">
                              <div class="col-md-4 text-align-right margin-top-4px">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>LMP</label>
                              </div>
                              <div class="col-md-5">
                                <div class="date-form">
                                  <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                         name="dp2" [(ngModel)]="LmpEgg" ngbDatepicker #d2="ngbDatepicker" #DateOfBirth="ngModel" required>
                                  <small class="form-text text-danger"
                                         *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                                  <a (click)="d2.toggle()" class="nav-link-hand">
                                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>
                                  </a>
                                </div>
                              </div>
                            </div>


                          </div>
                        </div>

                        <div class="row margin-top-5px">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-4 text-align-right margin-tg-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Start </label>
                              </div>


                              <div class="col-md-5">
                                <div class="date-form">
                                  <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                         name="dp3" [(ngModel)]="ProtocolStartDate" ngbDatepicker #d3="ngbDatepicker" #DateOfBirthStart="ngModel" required>
                                  <small class="form-text text-danger"
                                         *ngIf="(!DateOfBirthStart.valid && (DateOfBirthStart.dirty || DateOfBirthStart.touched) && DateOfBirthStart.errors.required)">(Field cannot be left blank)</small>

                                  <a (click)="d3.toggle()" class="nav-link-hand">
                                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                  </a>

                                </div>
                              </div>
                            </div>


                          </div>
                        </div>
                        <div class="row margin-top-5px">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-4 text-align-right margin-tg-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>End  </label>
                              </div>


                              <div class="col-md-5">
                                <div class="date-form">
                                  <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                         name="dp1" [(ngModel)]="ProtocolEndDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirthEnd="ngModel" required>
                                  <small class="form-text text-danger"
                                         *ngIf="(!DateOfBirthEnd.valid && (DateOfBirthEnd.dirty || DateOfBirthEnd.touched) && DateOfBirthEnd.errors.required)">(Field cannot be left blank)</small>
                                  <a (click)="d1.toggle()" class="nav-link-hand">
                                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                  </a>

                                </div>
                              </div>
                            </div>

                            <div class="row margin-top-5px">
                              <div class="col-md-4 text-align-right margin-top-4px">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Remarks</label>
                              </div>
                              <div class="col-md-6">
                                <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Remarks"
                                          name="Remarks"
                                          [(ngModel)]="Remarks" minlength="1" maxlength="100"
                                          #addconcerns_text="ngModel"></textarea>
                              </div>


                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    <div class="card-footer padding-top-2px padding-bottom-0px">

                      <button type="button"
                              class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right"
                              (click)="activeModal.close('Close click')">
                        Cancel
                      </button>
                      <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px"
                              [disabled]="DateOfBirth.errors?.required || DateOfBirthStart.errors?.required || DateOfBirthEnd.errors?.required"
                              (click)="SaveEpisode()">
                        Save
                      </button>
                    </div>
                  </div>

                  <div class="tab-pane" id="ConvertCycle">
                    <div class="card-body padding-bottom-0px padding-top-0px margin-left-0px padding-right-0px">
                      <div class="chatsd product-chart-wrapper product-chat-width-new-cycle agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                        <div class="row margin-top-10 ">
                          <div class="col-md-8 text-align-right margin-top-4px">
                            <label for="diaplayName"
                                   class="font-size-12px margin-bottom-0px">Want to use Already running Cycle?</label>
                          </div>
                          <div class="col-md-2 padding-left-0px margin-top-5px">
                            <button type="button"
                                    class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3"
                                    (click)="SelectCycle()">
                              <i class="fas fa-ellipsis-h"></i>
                            </button>
                          </div>
                        </div>
                        <div class="row margin-top-5px" *ngIf="DonorName">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-4 text-align-right margin-tg-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Selected Patient </label>
                              </div>
                              <div class="col-md-5">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">{{DonorName}}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row margin-top-5px" *ngIf="DonorCycleCode">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-4 text-align-right margin-tg-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Selected Cycle </label>
                              </div>
                              <div class="col-md-5">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">{{DonorCycleCode}}</label>
                              </div>
                            </div>
                          </div>
                        </div>                        
                        <div class="row margin-top-10 ">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row margin-top-5px">
                              <div class="col-md-4 text-align-right margin-top-4px">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>LMP</label>
                              </div>
                              <div class="col-md-5">
                                <div class="date-form">
                                  <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                         name="dp7" [(ngModel)]="DonorLmpEgg" ngbDatepicker #d7="ngbDatepicker" #DateOfBirth7="ngModel" required>
                                  <small class="form-text text-danger"
                                         *ngIf="(!DateOfBirth7.valid && (DateOfBirth7.dirty || DateOfBirth7.touched) && DateOfBirth7.errors.required)">(Field cannot be left blank)</small>

                                  <a (click)="d7.toggle()" class="nav-link-hand">
                                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>
                                  </a>
                                </div>
                              </div>
                            </div>


                          </div>
                        </div>
                        <div class="row margin-top-5px">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-4 text-align-right margin-tg-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Start </label>
                              </div>
                              <div class="col-md-5">
                                <div class="date-form">
                                  <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                         name="dp5" [(ngModel)]="DonorProtocolStartDate" ngbDatepicker #d5="ngbDatepicker" #DateOfBirthStart5="ngModel" required>
                                  <small class="form-text text-danger"
                                         *ngIf="(!DateOfBirthStart5.valid && (DateOfBirthStart5.dirty || DateOfBirthStart5.touched) && DateOfBirthStart5.errors.required)">(Field cannot be left blank)</small>

                                  <a (click)="d5.toggle()" class="nav-link-hand">
                                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row margin-top-5px">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-4 text-align-right margin-tg-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>End  </label>
                              </div>
                              <div class="col-md-5">
                                <div class="date-form">
                                  <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                         name="dp6" [(ngModel)]="DonorProtocolEndDate" ngbDatepicker #d6="ngbDatepicker" #DateOfBirthEnd6="ngModel" required>
                                  <small class="form-text text-danger"
                                         *ngIf="(!DateOfBirthEnd6.valid && (DateOfBirthEnd6.dirty || DateOfBirthEnd6.touched) && DateOfBirthEnd6.errors.required)">(Field cannot be left blank)</small>
                                  <a (click)="d6.toggle()" class="nav-link-hand">
                                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>
                                  </a>
                                </div>
                              </div>
                            </div>

                            <div class="row margin-top-5px">
                              <div class="col-md-4 text-align-right margin-top-4px">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Remarks</label>
                              </div>
                              <div class="col-md-6">
                                <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Remarks"
                                          name="Remarks"
                                          [(ngModel)]="Remarks" minlength="1" maxlength="100"
                                          #addconcerns_text="ngModel"></textarea>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    <div class="card-footer padding-top-2px padding-bottom-0px">

                      <button type="button"
                              class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right"
                              (click)="activeModal.close('Close click')">
                        Cancel
                      </button>
                      <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px"
                              [disabled]="DateOfBirth7.errors?.required || DateOfBirthStart5.errors?.required || DateOfBirthEnd6.errors?.required"
                              (click)="ConvertDonorEpisode()">
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
